export const SET_CONFIG = 'CS/SET_CONFIG';
export const CLEAR_CONFIG = 'CS/CLEAR_CONFIG';
